/**
 * Typography Scale — Modern Enterprise Design System
 *
 * Optimized for Inter with tighter tracking and modern proportions.
 * Inspired by Linear and Vercel's typographic approach.
 */

const typography = {
  fontFamily:
    "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",

  // Tight, impactful display headings
  h1: {
    fontSize: '2.25rem',
    fontWeight: 700,
    lineHeight: 1.2,
    letterSpacing: '-0.025em',
  },

  h2: {
    fontSize: '1.875rem',
    fontWeight: 700,
    lineHeight: 1.25,
    letterSpacing: '-0.02em',
  },

  h3: {
    fontSize: '1.5rem',
    fontWeight: 600,
    lineHeight: 1.3,
    letterSpacing: '-0.015em',
  },

  h4: {
    fontSize: '1.25rem',
    fontWeight: 600,
    lineHeight: 1.35,
    letterSpacing: '-0.01em',
  },

  h5: {
    fontSize: '1.125rem',
    fontWeight: 600,
    lineHeight: 1.4,
    letterSpacing: '-0.01em',
  },

  h6: {
    fontSize: '1rem',
    fontWeight: 600,
    lineHeight: 1.4,
    letterSpacing: '-0.005em',
  },

  subtitle1: {
    fontSize: '0.9375rem',
    fontWeight: 500,
    lineHeight: 1.5,
    letterSpacing: '-0.005em',
  },

  subtitle2: {
    fontSize: '0.8125rem',
    fontWeight: 600,
    lineHeight: 1.4,
    letterSpacing: '0em',
  },

  body1: {
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: 1.6,
    letterSpacing: '-0.005em',
  },

  body2: {
    fontSize: '0.8125rem',
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: '0em',
  },

  caption: {
    fontSize: '0.75rem',
    fontWeight: 450,
    lineHeight: 1.4,
    letterSpacing: '0.01em',
  },

  overline: {
    fontSize: '0.6875rem',
    fontWeight: 600,
    lineHeight: 1.4,
    textTransform: 'uppercase',
    letterSpacing: '0.06em',
  },

  button: {
    fontSize: '0.8125rem',
    fontWeight: 500,
    lineHeight: 1.4,
    letterSpacing: '0em',
    textTransform: 'none',
  },
};

export default typography;
